import LineEnvelopeIcon from 'LuxKit/Icons/line/LineEnvelopeIcon'
import Group from 'components/utils/Group'
import Sheet from 'components/utils/Sheet'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import SupportNumberButton from '../../../../LuxKit/Button/SupportNumberButton'
import TextLink from '../../../../LuxKit/TextLink'
import BodyText from '../../../../LuxKit/Typography/BodyText'

const Container = styled(Sheet)`
  margin-top: ${rem(24)}; /* PLEASE DO NOT DO THIS! THIS IS JUST LEGACY. */
`

interface Props {
  heading?: string;
  description?: string;
  contactNumber?: App.GeoContact;
  email?: string;
  refCode?: string;
  onSupportEmailClick?: () => void;
  onSupportNumberClick?: () => void;
  waiverMessage?: string;
}

function HelpPane({ heading = 'Need help? Call our support team', description, contactNumber, email, refCode, onSupportEmailClick, onSupportNumberClick, waiverMessage }: Props) {
  return <Container background="neutral-six" borderRadius="M" padding={16}>
    <Group direction="vertical" horizontalAlign="center" gap={12}>
      <BodyText variant="large" weight="bold">{heading}</BodyText>
      <BodyText variant="medium">
        {description || 'Our customer service team are available anytime, 24 hours, 7 days a week'}
      </BodyText>
      <SupportNumberButton onClick={onSupportNumberClick} currentContact={contactNumber} />
      {email && <div>
        <TextLink onClick={onSupportEmailClick} startIcon={<LineEnvelopeIcon />} href={`mailto:${email}`} rel="nofollow">{email}</TextLink>
      </div>}
      {refCode && <div>
        <BodyText variant="large" align="center" weight="bold">Reference Code</BodyText>
        <BodyText variant="large">{refCode}</BodyText>
      </div>}
      {waiverMessage && <BodyText variant="small" align="center">{waiverMessage}</BodyText>}
    </Group>
  </Container>
}

export default React.memo(HelpPane)
